import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import './RFQSummary.css';
import { TYPE } from '../utility/types';
import { getCurrentState } from '../recordDetail/states/states';

class RFQSummary extends Component {
  static get propTypes() {
    return {
      rfq: PropTypes.shape({
        RFQNumber: PropTypes.number,
        Client: PropTypes.string.isRequired,
        Verb: PropTypes.string,
        SummaryDescription: PropTypes.string,
        SalesPerson: PropTypes.string,
        ReceivedAtTimestamp: PropTypes.string,
        Status: PropTypes.string
      }).isRequired
    };
  }

  render() {
    const currentType = TYPE.RFQ;
    const { rfq } = this.props;
    const { RFQNumber, Client, Verb, SummaryDescription, SalesPerson, ReceivedAtTimestamp } = rfq;

    return (<div className="RFQSummary">
      <div className="RecordList-line">
        <span>
          <span>RFQ</span>
          <span className="RFQSummary-id">{RFQNumber}</span>
        </span>
        <span>{this.formatDate(ReceivedAtTimestamp)}</span>
      </div>
      <div className="RecordList-line">
        <span className="RFQSummary-client" title={Client}>{Client}</span>
        <span className="RFQSummary-salesperson" title={SalesPerson}>{SalesPerson}</span>
      </div>
      <div className="RecordList-line">
        <span>
          {Verb ? <span className="RFQSummary-verb">{Verb}</span> : undefined }
          {Verb ? <span>-</span> : undefined }
          <span title={SummaryDescription}>{SummaryDescription}</span>
        </span>
        <span>{getCurrentState(currentType, rfq)}</span>
      </div>
    </div>);
  }

  formatDate(date) {
    if (date) {
      return moment(date).format('DD/MM/YYYY');
    }
    return '';
  }
}

export default RFQSummary;



// WEBPACK FOOTER //
// ./src/recordList/RFQSummary.js